import { APIService } from '@services/api/common-services';
import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { APICONFIG } from '@config/api.config';
import { MicroSiteLeadData } from '.';

interface SiteVisitData {
	id: number;
	end_user_site_c: string;
	product1_demoed_code: string;
	product2_demoed_code: string;
	product1_demoed_name: string;
	product2_demoed_name: string;
	product1_discussed: string;
	product2_discussed: string;
	sfid: string | null;
	end_user_site_r_app_id_c: string;
	app_id: string;
	visit_image1: string;
	visit_image2: string;
	visit_image3: string;
	visit_image4: string;
	visit_image5: string;
	site_visit_status: string;
	product_available_at_site: string;
	verification_status_c: string;
}

interface IAddMicroSiteData {
	data: SiteVisitData;
	mutate: UseMutateFunction<MicroSiteLeadData, Error, MicroSiteLeadData, unknown>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useAddSiteVisitKaessMutation = (): IAddMicroSiteData => {
	const postMicroSiteAddData = async (siteLeadFormData: MicroSiteLeadData): Promise<MicroSiteLeadData> => {
		return await APIService.postData<MicroSiteLeadData>(APICONFIG.KAESS_VISIT_CREATE, siteLeadFormData);
	};

	const { mutate, error, isError, isPending, data } = useMutation({
		mutationFn: postMicroSiteAddData,
	});
	return {
		data,
		mutate,
		error,
		isError,
		isPending,
	};
};
